import { exists } from '@/api'

export interface ReferenceCreateBibliographyRequest {
  bibliographyRealId: number
  memo: string
}

export function ReferenceCreateBibliographyFromJSON(
  json: any
): ReferenceCreateBibliographyRequest {
  return ReferenceCreateBibliographyJSONTyped(json)
}

export function ReferenceCreateBibliographyJSONTyped(
  json: any
): ReferenceCreateBibliographyRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : 0,
    memo: exists(json, 'memo') ? json.memo : ''
  }
}

export function ReferenceCreateBibliographyToJSON(
  value?: ReferenceCreateBibliographyRequest | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    bibliography_real_id: value.bibliographyRealId,
    memo: value.memo
  }
}
